/** Lowercased titles for case-insensitive uniqueness (matches server duplicate check). */
export function nextDuplicateTemplateTitle(
  baseTitle: string,
  existingTitlesLower: Set<string>,
): string {
  const base = baseTitle ?? "";
  const primary = `${base}_duplicate`;
  if (!existingTitlesLower.has(primary.toLowerCase())) {
    return primary;
  }
  let n = 2;
  for (;;) {
    const candidate = `${base}_duplicate (${n})`;
    if (!existingTitlesLower.has(candidate.toLowerCase())) {
      return candidate;
    }
    n += 1;
    if (n > 10_000) {
      return `${base}_duplicate (${Date.now()})`;
    }
  }
}
